import { Box, Paper, Stack } from '@mui/material';
import { BodyMedium, LabelMedium, neutralVariant } from '../../../../styles';
import styled from '@emotion/styled';
import { shouldForwardProps } from '../../../../utils';

const StyledStack = styled(Stack)`
    width: 100%;
    max-width: 600px;
    min-width: 250px;
    display: flex;
    flex-direction: column;
`;

const StyledPaper = styled(Paper, shouldForwardProps)<{ isCompact: boolean }>`
    z-index: 1;
    position: absolute;
    top: 68px;
    overflow-y: auto;
    width: calc(100% - ${({ isCompact, theme }) => (isCompact ? theme.spacing(4) : '224px')});
    max-width: 600px;
    min-width: 250px;
    max-height: 280px;
    border-radius: 0 0 28px 28px;
    clip-path: inset(0px -10px -10px);
    padding: ${({ theme }) => theme.spacing(1)} 0 0 0;
    border-top: 1px solid ${neutralVariant[80]};
`;

const SearchSectionLabel = styled(LabelMedium)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.colors.onSurfaceVariant};
    padding: 0 ${({ theme }) => theme.spacing(1.5)};
`;

const Item = styled(Box, shouldForwardProps)<{ hasPadding: boolean; isActive: boolean }>`
    display: flex;
    align-items: center;
    height: 48px;
    padding: ${({ hasPadding, theme }) => (hasPadding ? `0 ${theme.spacing(1.5)}` : 0)};
    font-size: 16px;
    background-color: ${({ theme, isActive }) => isActive && theme.colors.disabled};
    justify-content: space-between;
    :hover {
        background-color: ${({ theme }) => theme.colors.disabled};
    }
`;

const Left = styled(Box)`
    display: flex;
    align-items: center;
`;

const Suggestions = styled(Stack)`
    > :last-child {
        border-bottom-left-radius: ${({ theme }) => theme.spacing(3)};
        border-bottom-right-radius: ${({ theme }) => theme.spacing(3)};
    }
`;

const EllipsedText = styled(BodyMedium)`
    font-size: inherit;
    overflow: hidden;
    position: relative;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export { StyledPaper, StyledStack, SearchSectionLabel, Item, Left, Suggestions, EllipsedText };
